<template>
  <v-app>
    <v-container>
      <!-- Navigation Bar -->
      <v-row>
        <v-col cols="12">
          <NavBar pageTitle="Messages" />
        </v-col>
      </v-row>

      <!-- Page Title -->
      <v-row class="mt-5">
        <v-col cols="12">
          <h1 class="page-title">Archive</h1>
        </v-col>
      </v-row>

      <!-- Tab Navigation (Below Title) -->
      <v-row class="tab-buttons mt-3">
        <v-col cols="12" class="text-center">
          <v-btn
            outlined
            :class="{ active: $route.name === 'Inbox' }"
            @click="$router.push('/messages/inbox')"
          >
            Inbox
          </v-btn>
          <v-btn
            outlined
            :class="{ active: $route.name === 'Sent' }"
            @click="$router.push('/messages/sent')"
          >
            Sent
          </v-btn>
          <v-btn
            outlined
            :class="{ active: $route.name === 'Trash' }"
            @click="$router.push('/messages/trash')"
          >
            Trash
          </v-btn>
          <v-btn
            outlined
            :class="{ active: $route.name === 'Archive' }"
            @click="$router.push('/messages/archive')"
          >
            Archive
          </v-btn>
        </v-col>
      </v-row>

      <!-- Content -->
      <v-row class="mt-5">
        <v-col cols="12">
          <p>You have no messages in Archive.</p>
        </v-col>
      </v-row>
    </v-container>
    <MENDFooter/>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import MENDFooter from "./MENDFooter.vue";

export default {
  name: "ArchivePage",
  components: {
    NavBar,
    MENDFooter
  },
};
</script>

<style scoped>
/* Title Styling */
.page-title {
  color: #08b6aa; /* Aqua Teal */
  font-weight: bold;
  text-align: center;
  margin-top: 32px;
}

/* Tab Buttons */
.tab-buttons .v-btn {
  color: #08b6aa; /* Aqua Teal */
  border-color: #08b6aa; /* Teal outline */
  background-color: white; /* White background */
  margin: 8px;
  transition: background-color 0.3s, color 0.3s;
}

.tab-buttons .v-btn:hover {
  background-color: #ff6d44; /* Bright Orange on hover */
  color: white;
}

.tab-buttons .v-btn.active {
  background-color: #08b6aa; /* Aqua Teal */
  color: white;
  border-color: #08b6aa; /* Keeps border consistent */
}
</style>
